import styles from "./ProgressBar.module.css";

interface ProgressBarProps {
  percent: number;
}

export const ProgressBar = ({ percent }: ProgressBarProps) => (
  <div
    className={styles.track}
    role="progressbar"
    aria-valuenow={Math.round(percent)}
    aria-valuemin={0}
    aria-valuemax={100}
    aria-label="Progreso de configuración"
  >
    <div className={styles.fill} style={{ width: `${percent}%` }} />
  </div>
);
